"use client";

import { getDocument } from "@faire/web/common/globals/getDocument";
import * as React from "react";

interface IPropTypes extends React.HTMLAttributes<HTMLDivElement> {
  onClickOutside?: (event?: Event) => void;
}

export default class ClickOutside extends React.Component<IPropTypes> {
  container?: HTMLDivElement | null;

  /*
  Synthetic click events created from a Facebook form are causing click outside to close the brand page sign up modal.
  This checks targets the transient Facebook form to prevent it from triggering the onClickOutside.
   */
  // eslint-disable-next-line @faire/prefer-arrow-methods
  static isFacebookClickEvent(event: any) {
    return (
      event?.target?.tagName === "INPUT" &&
      event?.target?.parentElement?.action === "https://www.facebook.com/tr/"
    );
  }

  render() {
    const { onClickOutside, ...props } = this.props;
    return (
      <div
        {...props}
        ref={(ref) => {
          this.container = ref;
        }}
      />
    );
  }

  componentDidUpdate(prevProps: IPropTypes) {
    if (this.props.onClickOutside && !prevProps.onClickOutside) {
      getDocument()?.addEventListener("click", this.handle, true);
    }
  }

  componentDidMount() {
    if (this.props.onClickOutside) {
      getDocument()?.addEventListener("click", this.handle, true);
    }
  }

  componentWillUnmount() {
    getDocument()?.removeEventListener("click", this.handle, true);
  }

  handle = (event?: MouseEvent) => {
    const { onClickOutside } = this.props;
    const el = this.container;
    if (
      onClickOutside &&
      el &&
      event &&
      !el.contains(event.target as HTMLElement) &&
      !ClickOutside.isFacebookClickEvent(event)
    ) {
      onClickOutside(event);
    }
  };
}
